import { useState, useEffect } from 'react';

import * as Styles from './Textarea.styles';

const Textarea = ({
  formik,
  placeholder,
  name,
  onChange,
  rows = 5,
  useBlur = false,
  isDetailPage = false,
  ...rest
}) => {
  const [value, setValue] = useState(formik?.values[name]);

  useEffect(() => {
    if (isDetailPage) {
      if (formik && formik?.values?.[name]) {
        setValue(formik.values[name]);
      }
      if (formik && !formik?.values?.[name] && value) {
        setValue('');
      }
    } else {
      if (formik && formik?.values?.[name] && !value) {
        setValue(formik.values[name]);
      }
    }
  }, [formik?.values?.[name], value]);

  const handleInputChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
    if (formik && !useBlur) {
      formik.handleChange(event);
    }
  };

  const handleBlur = () => {
    if (formik && useBlur) {
      formik.handleChange(event);
    }
  };

  return (
    <Styles.Textarea
      {...rest}
      rows={rows}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={handleInputChange}
      onBlur={handleBlur}
      multiline
    />
  );
};

export default Textarea;
